import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NzI18nModule } from '../i18n/nz-i18n.module';

import { NzRichTextEditorNetComponent } from './rich-text-editor.component';

@NgModule({
  declarations: [ NzRichTextEditorNetComponent ],
  exports     : [ NzRichTextEditorNetComponent ],
  imports     : [ CommonModule, NzI18nModule ]
})
export class NzRichTextEditorNetModule {
}
